<script>
  import { onMount } from "svelte";
  import { fade } from "svelte/transition";
  import { createEventDispatcher } from "svelte";
  import { persist, getLocal } from "../../../stores/store";
  const dispatch = createEventDispatcher();

  $: date = "No Date";
  let stored = getLocal("todos");
  $: todos = stored ? stored : [];
  let title = document.querySelector("#newTitle");

  const handleDate = e => {
    let input = document.querySelector("#date").value;
    date = new Date(input);
    date.setTime(date.getTime() + date.getTimezoneOffset() * 60 * 1000);
    date = date.toDateString();
    persist("date", date);
    let oldDate = localStorage.getItem("date");
    if (date !== oldDate) {
      localStorage.setItem("date", JSON.stringify(date));
    }
  };

  const addTodo = e => {
    if (!title) {
      document.getElementById("newTitle").focus();
    } else {
      let todo = {
        id: Math.random()
          .toString(36)
          .substr(2, 9),
        title,
        date
      };
      let updTodos = [...todos, todo];
      localStorage.setItem("todos", JSON.stringify(updTodos));
      todos = updTodos;
      dispatch("toggleAdd");
    }
  };

  onMount(() => {
    document.getElementById("newTitle").focus();
  });
</script>

<style>
  .addTaskWrapper {
    background-color: rgb(255, 255, 255, 0.8);
    color: #494d4e;
    padding: 2em;
    grid-gap: 0.5em;
    display: grid;
    justify-content: stretch;
    border-radius: 5px;
    box-shadow: -5px 19px 38px rgba(0, 0, 0, 0.3),
      -5px 15px 12px rgba(0, 0, 0, 0.22);
    position: relative;
  }

  .bottomRow {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .calendarWrap {
    min-width: 115px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-right: 1em;
  }

  .dateInput {
    margin-left: 1em;
    display: flex;
    align-items: center;
  }

  .add {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    cursor: pointer;
    position: relative;
  }

  input {
    min-height: 50px;
    border-radius: 5px;
    box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.22);
    outline: none;
    margin-bottom: 1em;
  }

  input:focus {
    border: 1px solid rgb(73, 77, 78, 0.7);
  }

  #date {
    margin-bottom: 0;
  }

  .imgs {
    position: relative;
  }

  img {
    width: 50px;
    height: 50px;
    transition: all 0.2s ease-in;
    cursor: pointer;
  }

  .send:hover {
    opacity: 0;
  }

  svg {
    top: 0;
    left: 0;
    position: absolute;
    opacity: 0;
    width: 50px;
    height: 50px;
    transition: all 0.2s ease-in;
    cursor: pointer;
  }

  svg:hover {
    opacity: 1;
  }

  @media only screen and (max-width: 1025px) {
    .calendar {
      display: none;
    }
    .dateInput {
      margin-left: 0;
    }
    .addText {
      display: none;
    }
  }
</style>

<div in:fade class="addTaskWrapper">
  <label for="newTitle">
    <h4>Title</h4>
  </label>
  <input bind:value={title} type="text" id="newTitle" required />
  <div class="bottomRow">
    <div class="calendarWrap">
      <img class="calendar" src="./images/calendar.svg" alt="add date" />

      <div class="dateInput">
        <input on:change={handleDate} type="date" id="date" name="date" />
      </div>
    </div>
    <div on:click={addTodo} class="add">
      <h3 class="addText">Add New Task &nbsp;</h3>
      <div class="imgs">
        <img class="send" src="./images/send.svg" alt="add task" />
        <svg
          width="80"
          height="80"
          viewBox="0 0 80 80"
          fill="none"
          xmlns="http://www.w3.org/2000/svg">
          <circle cx="40" cy="40" r="40" fill="#494D4E" />
          <g filter="url(#filter0_dd)">
            <path
              d="M61.1919 35.5636C64.5989 37.4994 64.5562 42.4239 61.1161
              44.3003L32.3943 59.9668C29.0624 61.7842 25 59.3726 25 55.5773L25
              23.5916C25 19.758 29.1368 17.3505 32.4701 19.2443L61.1919 35.5636Z"
              fill="white" />
            <path
              d="M60.6372 43.4224L31.9154 59.0889C29.2499 60.5428 26 58.6135 26
              55.5773L26 23.5916C26 20.5247 29.3095 18.5987 31.976
              20.1138L60.6979 36.433C63.4235 37.9817 63.3893 41.9213 60.6372
              43.4224Z"
              stroke="white"
              stroke-width="2" />
          </g>
          <defs>
            <filter
              id="filter0_dd"
              x="11"
              y="12.5843"
              width="58.7218"
              height="62.0001"
              filterUnits="userSpaceOnUse"
              color-interpolation-filters="sRGB">
              <feFlood flood-opacity="0" result="BackgroundImageFix" />
              <feColorMatrix
                in="SourceAlpha"
                type="matrix"
                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" />
              <feOffset dx="-2" dy="2" />
              <feGaussianBlur stdDeviation="2.5" />
              <feColorMatrix
                type="matrix"
                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0" />
              <feBlend
                mode="normal"
                in2="BackgroundImageFix"
                result="effect1_dropShadow" />
              <feColorMatrix
                in="SourceAlpha"
                type="matrix"
                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" />
              <feOffset dx="-4" dy="4" />
              <feGaussianBlur stdDeviation="5" />
              <feColorMatrix
                type="matrix"
                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" />
              <feBlend
                mode="normal"
                in2="effect1_dropShadow"
                result="effect2_dropShadow" />
              <feBlend
                mode="normal"
                in="SourceGraphic"
                in2="effect2_dropShadow"
                result="shape" />
            </filter>
          </defs>
        </svg>
      </div>
    </div>
  </div>
</div>
